<template>
  <div class="iapsz-container">
    <!-- Fixed Navigation -->
    <v-card class="navigation-card elevation-4">
      <v-tabs
        v-model="activeTab"
        show-arrows
        icons-and-text
        dark
        background-color="indigo darken-1"
        class="iapsz-tabs"
        center-active
      >
        <v-tab
          key="udaje_o_klientovi"
          :to="udaje_o_klientovi"
        >
          Údaje o klientovi
          <v-icon>mdi-account-details</v-icon>
        </v-tab>
        <v-tab
          key="swot"
          :to="swot"
        >
          SWOT
          <v-icon>mdi-chart-box</v-icon>
        </v-tab>
        <v-tab
          key="rizika_a_dohlad"
          :to="rizika_a_dohlad"
        >
          Riziká a dohľad
          <v-icon>mdi-shield-alert</v-icon>
        </v-tab>
        <v-tab
          key="potreby_plan"
          :to="potreby_plan"
        >
          Potreby Plán
          <v-icon>mdi-clipboard-list</v-icon>
        </v-tab>
        <v-tab
          v-if="item.permissions.add"
          key="socialne_programy"
          :to="socialne_programy"
        >
          Programy
          <v-icon>mdi-school</v-icon>
        </v-tab>
        <v-tab
          key="aktualny_stav"
          :to="aktualny_stav"
        >
          Aktuálny stav
          <v-icon>mdi-information</v-icon>
        </v-tab>
        <v-tab
          key="dokumenty"
          :to="dokumenty"
        >
          Dokumenty
          <v-icon>mdi-file-document-multiple</v-icon>
        </v-tab>
        <v-tab
          v-if="item.permissions.add"
          key="prehlad_zmien"
          :to="prehlad_zmien"
        >
          Prehľad zmien
          <v-icon>mdi-history</v-icon>
        </v-tab>
        <v-tab
          v-if="item.spracovatelia || item.spracovatelia_upsvar"
          key="spracovatelia"
          :to="spracovatelia"
        >
          Spracovatelia
          <v-icon>mdi-account-group</v-icon>
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- Content Area with proper spacing -->
    <div class="content-wrapper">
      <v-card
        shaped
        class="content-card elevation-2"
      >
        <v-card-title class="primary--text">
          <v-icon
            left
            color="primary"
          >
            mdi-account-circle
          </v-icon>
          {{ item.prisoner_full.string_details || 'Načítavam...' }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <ErrorBoundary @report="handleError">
            <router-view />
          </ErrorBoundary>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import { APIService } from "@/http/APIService.js";
import ErrorBoundary from "@/components/ErrorBoundary.vue";

const apiService = new APIService();
export default {
  components: {
    ErrorBoundary,
  },

  data() {
    return {
      timer: "",
      headline: "",
      activeTab: null,

      permissions: {},
      item: {
        prisoner_full: { string_details: "" },
        permissions: { add: false },
        spracovatelia: null,
        spracovatelia_upsvar: null,
      },
    };
  },

  computed: {
    udaje_o_klientovi() {
      return "/iapsz/" + this.$route.params.id + "/udaje_o_klientovi";
    },
    rizika_a_dohlad() {
      return "/iapsz/" + this.$route.params.id + "/rizika_a_dohlad";
    },
    swot() {
      return "/iapsz/" + this.$route.params.id + "/swot";
    },
    potreby_plan() {
      return "/iapsz/" + this.$route.params.id + "/potreby_plan";
    },
    socialne_programy() {
      return "/iapsz/" + this.$route.params.id + "/socialne_programy";
    },
    aktualny_stav() {
      return "/iapsz/" + this.$route.params.id + "/aktualny_stav";
    },
    dokumenty() {
      return "/iapsz/" + this.$route.params.id + "/dokumenty";
    },
    prehlad_zmien() {
      return "/iapsz/" + this.$route.params.id + "/prehlad_zmien";
    },
    spracovatelia() {
      return "/iapsz/" + this.$route.params.id + "/spracovatelia";
    },
  },
  mounted() {
    apiService.getIapszForm(this.$route.params.id).then((response) => {
      this.item = response;
    });
  },

  beforeDestroy() { },

  methods: {
    handleError(error) {
      // Log error to console in development
      // Removed for production build
      
      // TODO: Send to error tracking service (Sentry, etc.)
      // Example: Sentry.captureException(error);
    },
  },
};
</script>
<style scoped>
.iapsz-container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.navigation-card {
  position: sticky;
  top: 0;
  z-index: 10;
  border-radius: 0 !important;
}

.iapsz-tabs {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.content-wrapper {
  padding: 24px;
  padding-top: 32px;
}

.content-card {
  max-width: 1400px;
  margin: 0 auto;
  background-color: white;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .content-wrapper {
    padding: 16px;
    padding-top: 24px;
  }
}

@media (max-width: 600px) {
  .content-wrapper {
    padding: 8px;
    padding-top: 16px;
  }
}
</style>